<div class="page-header">
  <div class="page-header__main">
    <div class="page-header__breadcrumb">
      <span>{{ section }}</span>
      <span class="page-header__divider">/</span>
      <span class="page-header__current">{{ pageTitle }}</span>
    </div>

    <div class="page-header__title-row">
      <h1 class="page-header__title">{{ pageTitle }}</h1>

      @if (badgeText) {
        <span class="page-header__badge">{{ badgeText }}</span>
      }
      @if (titleIconPath) {
     <img class="page-header__title-icon" [src]="titleIconPath" [alt]="pageTitle" />
}
    </div>

    @if (subtitle) {
      <p class="page-header__subtitle">{{ subtitle }}</p>
    }
  </div>

  <div class="page-header__actions">
    @for (action of actions; track action.label) {
      <button
        type="button"
        class="header-button"
        [class.header-button--primary]="action.variant === 'primary'"
        [class.header-button--secondary]="action.variant === 'secondary'"
        [class.header-button--ghost]="action.variant === 'ghost'"
        [disabled]="action.disabled"
        (click)="onActionClick(action)"
      >
        @if (action.icon) {
          <img [src]="action.icon" [alt]="action.label" />
        }
       <span class="header-button__label"
       > {{ action.label }}
        </span>
      </button>
    }
  </div>
</div>